import { PaginationBar } from 'mailup-web-components'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { getCampaignListCallback } from '../recoil/callbacks/callbacks'
import { resultsState, searchState } from '../recoil/state/page'

const Pagination = () => {
  const intl = useIntl()

  const getCampaignList = useRecoilCallback(getCampaignListCallback, [])

  const { pageNumber, pageSize } = useRecoilValue(searchState)
  const { totalItems } = useRecoilValue(resultsState)

  const { current: handleChangePageNumber } = useRef((pageNumber) => {
    getCampaignList({ pageNumber })
  })
  const { current: handleChangePageSize } = useRef((pageSize) => {
    getCampaignList({ pageSize, pageNumber: 1 })
  })

  return (
    <>
      <PaginationBar
        data-mu-test='pager'
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalItems={totalItems}
        handleChangePage={handleChangePageNumber}
        handleChangePageSize={handleChangePageSize}
        strings={{
          of: intl.formatMessage({ id: 'Load.Pager.Of' }),
          label: intl.formatMessage({ id: 'Load.Pager.Items' })
        }}
      />
    </>
  )
}

export default Pagination
